

import {
  PendingRegistration,
  RegistrationValues,
} from "../components/register/types/registration";
import { authApi, GoogleAuthResponse, LoginResponse, RegisterResponse, VerifyResponse } from "../services/auth.api";
import { ApiError } from "../services/api";

export const authService = {
  register: async (
    data: RegistrationValues
  ): Promise<RegisterResponse> => {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (value instanceof File) {
          formData.append(key, value);
        } else {
          formData.append(key, String(value));
        }
      }
    });

    return authApi.register(formData);
  },

  verifyEmail: async (
    email: string,
    code: string
  ): Promise<VerifyResponse> => {
    return authApi.verifyEmail(email, code);
  },

  resendVerification: async (
    email: string
  ): Promise<{ sent: boolean }> => {
    return authApi.resendVerification(email);
  },

  forgotPassword: async (
    email: string
  ): Promise<{ sent: boolean }> => {
    return authApi.forgotPassword(email);
  },

  login: async (
    email: string,
    password: string
  ): Promise<LoginResponse> => {
    return authApi.login(email, password);
  },

  googleAuth: async (
    accessToken: string
  ): Promise<GoogleAuthResponse> => {
    return authApi.googleAuth(accessToken);
  },

   me: async () => {
    return await authApi.me();
  },
};

export { ApiError };
